import React from 'react'

export const PageBreak: React.FC = () => {
  return <div id='ProposalPageBreak'></div>
}
